<template>
    <div>



    </div>
</template>


<script>
    export default {
        name: 'monev_navbar',
            data () {
            return {
                msg: 'aset_navbar',
                apakah: 'Telasomu'
            }
        }
    }
</script>
